import { SxProps, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { currencyToNumber, maskCurrency } from '../../utils/maks'
import { useTranslation } from 'react-i18next'

interface Props {
    value: number
    setValue(v: number): void
    label: string
    sx?: SxProps
    error?: string
    onClick?(): void
    size?: 'small' | 'medium'
    maxValue?: number
    fontSize?: string
    allowNegative?: boolean
}

export const PorcentageField = ({
    value,
    setValue,
    label,
    sx,
    error,
    onClick,
    size,
    maxValue,
    fontSize = '16px',
    allowNegative
}: Props) => {
    const { t } = useTranslation()
    const [localValue, setLocalValue] = useState('')

    useEffect(() => {
        setLocalValue(maskCurrency(value))
    }, [value])

    return (
        <TextField
            sx={{
                ...sx,
            }}
            error={Boolean(error)}
            helperText={error}
            onClick={onClick}
            value={localValue}
            label={t(label)}
            onChange={(e) => {
                let { value } = e.target
                const regex = allowNegative ? /[^\d-]/g : /\D/g
                value = value.replace(regex, '')

                if (allowNegative && value.includes('-')) {
                    const parts = value.split('-')
                    value = '-' + parts.join('').replace('-', '')
                }

                const numberValue = Number(value) / 100
                if (typeof maxValue === 'number' && numberValue > maxValue) return
                setValue(numberValue)
            }}
            InputProps={{
                endAdornment: (
                    <Typography
                        sx={{
                            mr: '2px',
                            whiteSpace: 'nowrap',
                            fontSize: fontSize,
                        }}
                    >
                        %
                    </Typography>
                ),
                style: {
                    fontSize: fontSize
                }
            }}
            size={size}
        />
    )
}
